import './MacCarousel.css';

import macNeo2026 from '../../../assets/apple/mac/mac2026/MacNeo.png';
import macBookAir2026 from '../../../assets/apple/mac/mac2026/MacBookAir.png';
import macBookPro2026 from '../../../assets/apple/mac/mac2026/MacBookPro.png';

import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { useNavigate } from 'react-router-dom';

const macSlides = [
  {
    key: 'macneo',
    title: 'MacBook Neo',
    subtitle: 'Introducing MacBook Neo, an amazing Mac at a surprising price.',
    price: 'Starts at Rs. 69,900',
    emi: 'Credit Card EMI Available.',
    image: macNeo2026,
    productId: 3,
    slideClass: 'mac2026-slide mac2026-slide-neo',
  },
  {
    key: 'macair',
    title: 'MacBook Air',
    subtitle: 'Thin. Light. Built for everyday power.',
    price: 'Starts at Rs. 1,19,900',
    emi: 'Credit Card EMI Available.',
    image: macBookAir2026,
    productId: 5,
    slideClass: 'mac2026-slide mac2026-slide-air',
  },
  {
    key: 'macpro',
    title: 'MacBook Pro',
    subtitle: 'Now with M5, M5 Pro and M5 Max.',
    price: 'Starts at Rs. 1,89,900',
    emi: 'Credit Card EMI Available.',
    image: macBookPro2026,
    productId: 8,
    slideClass: 'mac2026-slide mac2026-slide-pro',
  },
];

const MacCarousel = () => {
  const navigate = useNavigate();
  const [swiperInstance, setSwiperInstance] = useState(null);

  const pauseAutoplay = () => {
    swiperInstance?.autoplay?.stop();
  };

  const resumeAutoplay = () => {
    swiperInstance?.autoplay?.start();
  };

  const handleViewDetails = (productId) => {
    navigate(`/applestore/iphone-products-list/iphone-detail-page/mac/${productId}`);
  };

  return (
    <Swiper
      modules={[Pagination, Navigation, Autoplay]}
      navigation
      pagination={{ type: 'progressbar', clickable: true }}
      slidesPerView={1}
      spaceBetween={0}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      style={{ padding: '0 0 3% 0', borderRadius: '40px' }}
      onSwiper={(swiper) => setSwiperInstance(swiper)}
    >
      {macSlides.map((slide) => (
        <SwiperSlide key={slide.key}>
          <section className={slide.slideClass}>
            <div className="mac2026-content">
              <h1 className="mac2026-title">{slide.title}</h1>
              <h2 className="mac2026-subtitle">{slide.subtitle}</h2>

              <h3 className="mac2026-price">{slide.price}</h3>
              <p className="mac2026-emi">{slide.emi}</p>

              <div className="mac2026-image-wrapper">
                <img src={slide.image} alt={slide.title} className="mac2026-image" />
              </div>

              <button
                className="mac2026-view-details-btn"
                onClick={() => handleViewDetails(slide.productId)}
                onMouseEnter={pauseAutoplay}
                onMouseLeave={resumeAutoplay}
              >
                View Details
              </button>
            </div>
          </section>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default MacCarousel;
